module.exports = __webpack_public_path__ + "img/794E40_361612_4C2A21_441B1B-256px.4bb892cd.png";